export function unproxify(obj: any) {
  return JSON.parse(JSON.stringify(obj))
}
